import React from 'react';
import classnames from 'classnames';
import { Table, TableProps, TableColumn } from 'tea-component';
import ReportCard from '../../../components/ReportCard';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { CARD_TITLE, getColumnsReadonly } from './utils';
import { DPS_REPORT_MODULE_KEY } from '../../constants';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportUpdatesOfTheWeekVO } from '@gp/types/dpsReport/v3';

interface IReviewUpdatesOfWeekProps extends IBaseProps, Omit<TableProps, 'columns'> {
  // 标题
  title?: string;
  // 模块数据
  value: IDPSReportUpdatesOfTheWeekVO[];
}

const ReviewUpdatesOfWeek: React.FC<IReviewUpdatesOfWeekProps> = (props) => {
  const { style, className, title, value: records } = props;

  const columns: TableColumn<IDPSReportUpdatesOfTheWeekVO>[] = getColumnsReadonly();

  return (
    <ReportCard
      style={style}
      className={classnames('dbg-dps-report__hightlights-table-card', className)}
      moduleKey={DPS_REPORT_MODULE_KEY.CHANGES}
      title={title || CARD_TITLE}
    >
      <Table
        style={style}
        className={classnames(
          'dbg-table-vertical-align-top dbg-dps-report__boeder-table dbg-dps-report__hightlights-table-card dbg-dps-report-updates-table',
          className,
        )}
        columns={columns}
        records={records}
        recordKey={getRecordKeyOfMockable}
      />
    </ReportCard>
  );
};

export default ReviewUpdatesOfWeek;
